import React from "react";
import styled from "styled-components";
import Theme from "@adsk/alloy-react-theme";
import { PhotosFilledIcon } from "@adsk/alloy-react-icon";
import { useTranslations } from "@adsk/acc-issues-translations";

const ImageErrorState = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${Theme.colors.charcoal050};
  text-align: center;
  flex: auto;
`;

const ErrorStateIcon = styled(PhotosFilledIcon)`
  opacity: 0.5;
`;

export const IssueSnapshotImageErrorState = () => {
  const { T } = useTranslations();

  return (
    <ImageErrorState>
      <ErrorStateIcon />
      <span>{T.translate("thumbnailField.errorStateText")}</span>
    </ImageErrorState>
  );
};
